const EXCLUDED_CATEGORIES = ['extra_data', 'gwas_links'];

const SNP_PLOTS = {
  BARPLOT: 'barplot',
};

export { EXCLUDED_CATEGORIES, SNP_PLOTS };
